export default "__VITE_ASSET__B7883fcP__"